module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-700italic.woff2?a49393f2171a2f4d6927ce6c14f73dbc";